import { Flex, Text, Image, Button } from "@fluentui/react-northstar";
import { Link } from "@smb/ui-link";
import { useTranslation } from "react-i18next";

import { PRIVACY_TERMS_URL } from "../../environments/environment";
import { ErrorPages } from "../../types/Device.types";
import { Paths } from "../../types/paths";

import { GenericErrorPageProps } from "./GenericErrorPage.types";
import { useLaunchErrorMessage } from "./utils/useLaunchErrorMessage";
import { useGenericErrorPageStyles } from "./GenericErrorPage.styles";

export const GenericErrorPage: React.FC<GenericErrorPageProps> = ({
  errorPage,
}) => {
  const errorPageStyles = useGenericErrorPageStyles();
  const { t } = useTranslation();

  const { description, title, altMessage } = useLaunchErrorMessage(errorPage);

  const redirectToHomePage = () => {
    window.location.pathname = Paths.Home;
  };

  return (
    <Flex
      column
      vAlign="center"
      hAlign="center"
      styles={errorPageStyles.layout}
      gap="gap.medium"
    >
      <Flex vAlign="center" hAlign="center">
        <Image
          data-testid="genericErrorImage"
          fluid
          styles={errorPageStyles.imgStyles}
          src={"/assets/images/genericErrorDark.svg"}
          alt={altMessage}
        />
      </Flex>

      {title && (
        <Text
          content={<>{title}</>}
          styles={errorPageStyles.titleStyles}
          as="h1"
          size="larger"
          weight="bold"
          align="center"
          data-testid="errorPanelTitle"
        />
      )}
      {description && (
        <Text
          title={description}
          styles={errorPageStyles.descriptionStyles}
          content={<>{description}</>}
          size="large"
          data-testid="errorPanelDescription"
        />
      )}

      {errorPage === ErrorPages.AcsCallError && (
        <Button
          data-testid="retryAfterFailedCallButton"
          onClick={redirectToHomePage}
          styles={errorPageStyles.actionButton}
          content={
            <Text
              content={<>{t("TRY_AGAIN")}</>}
              size="large"
              weight="semibold"
              align="center"
            />
          }
        />
      )}

      <Flex column styles={errorPageStyles.footer} gap="gap.medium">
        <Text align="center" size="medium" weight="regular">
          <Text content={<>{t("NEED_HELP_CONTACT_CLINIC")}</>} />
        </Text>

        <Link
          content={<>{t("PRIVACY_COOKIES")}</>}
          href={PRIVACY_TERMS_URL}
          textProps={{
            align: "center",
            size: "small",
            weight: "regular",
          }}
          linkProps={{ target: "_blank", rel: "noopener" }}
        />
      </Flex>
    </Flex>
  );
};
